import React, { useEffect, useState, useRef } from 'react';
import { useParams } from 'react-router-dom'
import {
  Box,
  Text,
  useDisclosure,
  Alert,
  AlertIcon,
  Table,
  Tbody,
  Td,
  Tr,
  Button, Flex,
  Accordion,
  AccordionItem,
  AccordionButton,
  AccordionPanel,
  AccordionIcon,
  Badge,
  useToast,
  HStack,
  AlertDialog, AlertDialogBody, AlertDialogFooter, AlertDialogHeader, AlertDialogContent, AlertDialogOverlay,Select,
  Switch,
  useColorModeValue,
} from '@chakra-ui/react';
import axios from "axios";
import EnrolmentForm from '../Components/EnrolmentForm';
import { EnrolmentData, EnrolmentMetaData, CombinedEnrolment, StudentMetaData, Student } from "../Common/types";
import { jwtDecode } from "jwt-decode";
import { toUtcISOString, parseUtc, fmtLocal } from "../../utils/dates";
import { useNavigate } from "react-router-dom";
import { useTenant } from "../Routers/TenantContextProvider";

// Define the expected structure of the token payload
interface TokenPayload {
    sub: string;       // Typically the username or user ID
    role_id: number;   // Role ID
    tenant_id: number; // Tenant ID
    exp?: number;      // Expiration timestamp (optional)
  }
  

interface User{
    user_id : number;
    username : string;
    email : string;
    password : string;
    tenant_id : number;
    role_id:number;
    is_active : boolean;
}

export const EnrolmentStatus = {
    PENDING:"pending",
    UNDER_REVIEW: "under-review",
    REVIEWED: "reviewed",
    USER_CREATED: "user-created",
    EXECUTED: "executed",
    REJECTED: "rejected",
} as const;

export type EnrolmentStatus = (typeof EnrolmentStatus)[keyof typeof EnrolmentStatus];

  const ReviewEnrolment = () => {

    const [completedSteps, setCompletedSteps] = useState<number[]>([]);
    const [currentStep, setCurrentStep] = useState(0);

    const { isOpen, onOpen, onClose } = useDisclosure();
    const cancelRef = useRef<HTMLButtonElement>(null);
    const [rejectionReason, setRejectionReason] = useState<string>("");
        const navigate = useNavigate();

    const { tenant, loading, error } = useTenant();
    const [processingStep, setProcessingStep] = useState<number | null>(null);

    const [enrolmentMode, setEnrolmentMode] = useState<"offline" | "online">("offline");

    const enrolmentModeBg = useColorModeValue("gray.50", "gray.700");
const enrolmentModeBorder = useColorModeValue("gray.200", "gray.600");
const enrolmentModeMuted = useColorModeValue("gray.600", "gray.300");
const enrolmentModeActive = useColorModeValue("blue.600", "blue.300");
const enrolmentModeInactive = useColorModeValue("gray.500", "gray.400");


    const steps = [
        { id: 0, label: 'Step 1 : Review Enrolment', content: 'Review and update enrolment details in staging.' },
        { id: 1, label: 'Step 2 : Create User', content: 'Create User for the Student.' },
        { id: 2, label: 'Step 3 : Create Student', content: 'Create Student and attach to the User created in previous step.' },
      ];

      const statusToConfirmedSteps: Record<EnrolmentStatus, number[]> = {
        [EnrolmentStatus.PENDING]: [],
        [EnrolmentStatus.UNDER_REVIEW]: [],
        [EnrolmentStatus.REVIEWED]: [1],
        [EnrolmentStatus.USER_CREATED]: [1, 2],
        [EnrolmentStatus.EXECUTED]: [1, 2, 3],
        [EnrolmentStatus.REJECTED]: [1, 2, 3],
    };

    const getStepStatus = (status: EnrolmentStatus | null) => {
        switch (status) {
          case EnrolmentStatus.PENDING:
          case EnrolmentStatus.UNDER_REVIEW:
            return {
              enabledSteps: [0],
              badges: ["In Progress", null, null],
            };
          case EnrolmentStatus.REVIEWED:
            return {
              enabledSteps: [1],
              badges: ["Confirmed", "In Progress", null],
            };
          case EnrolmentStatus.USER_CREATED:
            return {
              enabledSteps: [2],
              badges: ["Confirmed", "Confirmed", "In Progress"],
            };
          case EnrolmentStatus.EXECUTED:
            return {
              enabledSteps: [],
              badges: ["Confirmed", "Confirmed", "Confirmed"],
            };
          case EnrolmentStatus.REJECTED:
                return {
                  enabledSteps: [],
                  badges: ["Confirmed", "Confirmed", "Confirmed"],
                };
          default:
            return {
              enabledSteps: [0],
              badges: ["In Progress", null, null],
            };
        }
    }

  
    const [message, setMessage] = useState<string>("");
    const [user, setUser] = useState<string | null>(null);

    const [enrolmentDetails, setEnrolmentDetails] = useState<EnrolmentData | null>(null); // Adjust type to match FormData
    const [enrolmentMetaData, setEnrolmentMetaData] = useState<EnrolmentMetaData | null>(null);

    const [studentMetaData, setStudentMetaData] = useState<StudentMetaData | null>(null);

    const [studentUser, setStudentUser] = useState<User | null>(null); 

    const { enrolment_id } = useParams<{ enrolment_id: string }>();
    console.log("enrolment id is ",enrolment_id);

    const isEnrolmentStatus = (status: string | null | undefined): status is EnrolmentStatus => {
        return !!status && Object.values(EnrolmentStatus).includes(status as EnrolmentStatus);
      };

    const confirmedSteps = enrolmentMetaData && isEnrolmentStatus(enrolmentMetaData.status)
    ? statusToConfirmedSteps[enrolmentMetaData.status]
    : [];
    
    // Explicitly handle undefined and narrow to EnrolmentStatus | null
    const status: EnrolmentStatus | null = isEnrolmentStatus(enrolmentMetaData?.status)
        ? (enrolmentMetaData?.status as EnrolmentStatus)
        : null;

    const { enabledSteps, badges } = getStepStatus(status);

    const toast = useToast();

const handleConfirm = async (stepId: number) => {
    if (processingStep !== null) return;   // NEW — hard stop against concurrent/duplicate clicks
    setProcessingStep(stepId);

    try {
        if (!completedSteps.includes(stepId)) {
            setCompletedSteps([...completedSteps, stepId]);
        }

        if (stepId === 0) {
            await confirmEnrolmentReview();
        } else if (stepId === 1) {
            await saveStudentUser();
        } else if (stepId === 2) {
            await saveStudentInEducationSchema();
        }

        setCurrentStep(stepId + 1);
    } finally {
        setProcessingStep(null);   // NEW — always release, success or failure
    }
};
 
    const handleReject = () => {
        setRejectionReason(""); // Reset reason on open
        onOpen();
      };

const handleRejectConfirmed = async () => {

    if (!rejectionReason) return;

    onClose();

    try {
        if (!enrolmentMetaData) {
            toast({
                title: "Missing Metadata",
                description: "Enrolment metadata is missing. Cannot reject.",
                status: "error",
                duration: 3000,
                isClosable: true,
            });
            return;
        }

        const status: EnrolmentStatus | null = isEnrolmentStatus(enrolmentMetaData?.status)
            ? (enrolmentMetaData.status as EnrolmentStatus)
            : null;

        if (!status) {
            toast({
                title: "Invalid Status",
                description: "The enrolment status is invalid. Cannot reject.",
                status: "error",
                duration: 3000,
                isClosable: true,
            });
            return;
        }

        const normalizedUser = user ?? undefined;

        const updatedMetaData = {
            id: enrolmentMetaData.id,
            status: EnrolmentStatus.REJECTED,   // FIXED: was hardcoded to UNDER_REVIEW
            actioned_by: normalizedUser,
            created_at: enrolmentMetaData.created_at,
            updated_at: enrolmentMetaData.updated_at,
            user_id: status === EnrolmentStatus.USER_CREATED ? undefined : enrolmentMetaData.user_id,   // FIXED: was unconditionally undefined
            rejection_reason: rejectionReason,
            enrolmentMode: enrolmentMetaData.enrolmentMode,
        };

        console.log("Rejecting enrolment — outgoing payload:", updatedMetaData);

        const apiurl = process.env.REACT_APP_API_URL || "https://default-url.com";
        const updateResponse = await axios.put(
            `${apiurl}/update-enrolment-metadata/${enrolmentMetaData.id}`,
            updatedMetaData,
            {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem('token')}`,
                },
            }
        );

        setEnrolmentMetaData(updateResponse.data);   // always sync, regardless of branch below

        if (updateResponse.data.status === EnrolmentStatus.REJECTED) {
            setMessage("Enrolment successfully rejected.");

            toast({
                title: "Enrolment Rejected",
                description: `Enrolment with ID ${enrolmentMetaData.id} has been rejected.`,
                status: "success",
                duration: 3000,
                isClosable: true,
            });
        } else {
            console.warn(
                "update-enrolment-metadata returned unexpected status:",
                updateResponse.data.status,
                "expected:",
                EnrolmentStatus.REJECTED,
                "— payload sent was:",
                updatedMetaData.status
            );
            toast({
                title: "Update Failed",
                description: "The enrolment status could not be updated.",
                status: "warning",
                duration: 3000,
                isClosable: true,
            });
            return;
        }

        if (status === EnrolmentStatus.USER_CREATED && enrolmentMetaData.user_id) {
            await axios.delete(`${apiurl}/delete-user/${enrolmentMetaData.user_id}`, {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem('token')}`,
                },
            });

            toast({
                title: "User Deleted",
                description: `User with ID ${enrolmentMetaData.user_id} has been successfully deleted.`,
                status: "success",
                duration: 3000,
                isClosable: true,
            });
        }
    } catch (error) {
        if (axios.isAxiosError(error)) {
            toast({
                title: "Request Failed",
                description: error.response?.data?.detail || "An error occurred while processing the request.",
                status: "error",
                duration: 3000,
                isClosable: true,
            });
        } else {
            toast({
                title: "Unexpected Error",
                description: "An unexpected error occurred.",
                status: "error",
                duration: 3000,
                isClosable: true,
            });
        }

        console.error("Error in handleReject:", error);
    }
};
     
    // Function to get tenant_id from the token
const getUserFromToken = (token: string): string | null => {
    try {
        const decoded: TokenPayload = jwtDecode<TokenPayload>(token);
        return decoded.sub ;
    } catch (error) {
        console.error("Error decoding token:", error);
        return null;
    }
    };


  useEffect(() => {

    const token = localStorage.getItem("token");
    if (token) {
        const username = getUserFromToken(token);
        console.log("User:", username);
        setUser(username);
    }

    const fetchEnrolmentDetails = async () => {
      try {
        const apiurl = process.env.REACT_APP_API_URL || "https://default-url.com";
        const response = await axios.get(`${apiurl}/enrolment/${enrolment_id}`, {
            headers: {
              Authorization: `Bearer ${localStorage.getItem('token')}`,
            },
          });
       // setEnrolmentDetails(response.data); // Assuming the API returns the enrolment data in the correct format
        setEnrolmentDetails({
            mother: response.data.mother,
            father: response.data.father,
            emergencyContact: response.data.emergencyContact,
            student: response.data.student,
            preferredCourses: response.data.preferredCourses,
            heardAboutUs: response.data.heardAboutUs,
            medicalAndOtherInfo: response.data.medicalAndOtherInfo,
            tenant_id: response.data.tenant_id,
            enrolmentMode: response.data.enrolmentMode,   // NEW
        });
        setEnrolmentMetaData({
            id: response.data.id,
            status: response.data.status,
            actioned_by: response.data.actioned_by,
            created_at: new Date(response.data.created_at),
            updated_at: new Date(response.data.updated_at),
            user_id:response.data.user_id,
            rejection_reason : response.data.rejection_reason,
            enrolmentMode: response.data.enrolmentMode,
        });

        setStudentMetaData({
            student_id:0,
            is_active: true,
            user_id: response.data.user_id,
            actioned_by: response.data.actioned_by,
            created_at: new Date(response.data.created_at),
            updated_at: new Date(response.data.updated_at),
            enrolmentMode: response.data.enrolmentMode,
        });

        setStudentUser({
            tenant_id: response.data.tenant_id, 
            user_id: response.data.user_id, 
            username: response.data.student.surname + response.data.id, 
            email: response.data.student.email, 
            password:response.data.student.givenName+"@"+response.data.student.contactNo, 
            role_id:4, 
            is_active: false
        });

      } catch (error) {
        console.error('Error fetching enrolment details:', error);
      }
    };

    if (Number(enrolment_id) > 0)
    {
      fetchEnrolmentDetails();
      console.log("Enrolment details fetched got the student details")
    }
  }, [enrolment_id]);

//   if (!enrolmentDetails) {
//     return <p>Loading enrolment details...</p>; // Add a loading spinner if needed
//   }

const updateEnrolment = async (enrolmentData: EnrolmentData) => {
    setEnrolmentDetails(enrolmentData);
    try {
        if (!enrolmentMetaData) {
            toast({
                title: "Missing Metadata",
                description: "Enrolment metadata is missing. Cannot update.",
                status: "error",
                duration: 3000,
                isClosable: true,
            });
            return;
        }

        if (!enrolmentMetaData.id) {
            throw new Error("Enrolment ID is missing. Cannot update.");
        }

        const normalizedUser = user ?? undefined;

        // CHANGED: enrolmentMode always carried forward from the existing record's
        // metadata — never from the create-only toggle. This function only ever
        // runs against an enrolment that already exists, so its mode was fixed
        // at creation time and must not change here.
        const updatedMetaData = {
            id: enrolmentMetaData.id,
            status: EnrolmentStatus.UNDER_REVIEW,
            actioned_by: normalizedUser,
            created_at: enrolmentMetaData.created_at,
            updated_at: enrolmentMetaData.updated_at,
            user_id: undefined,
            rejection_reason: rejectionReason,
            enrolmentMode: enrolmentMetaData.enrolmentMode,   // NEW — was missing from this payload entirely
        };

        console.log("Agreed To Field Value", enrolmentData.medicalAndOtherInfo.agreeToCosts);

        const payload: CombinedEnrolment = {
            ...updatedMetaData,
            ...enrolmentData,
            enrolmentMode: enrolmentMetaData.enrolmentMode,   // NEW — explicit, so a stale/mismatched
                                                                // value on enrolmentData (spread above)
                                                                // can never silently win the merge order
        };

        // NOTE: single endpoint regardless of mode — /update-enrolment/{id} is backed
        // by CombinedEnrolment/EnrolmentCoreBase on the backend, which already
        // handles both online and offline records correctly. No branching needed here.
        const apiurl = process.env.REACT_APP_API_URL || "https://default-url.com";
        const response = await axios.put(`${apiurl}/update-enrolment/${enrolmentMetaData.id}`, payload, {
            headers: {
                Authorization: `Bearer ${localStorage.getItem('token')}`,
            },
        });

        if (response.data.status === EnrolmentStatus.UNDER_REVIEW) {
            setEnrolmentMetaData(response.data);

            toast({
                title: "Enrolment Updated",
                description: `Enrolment with ID ${enrolmentMetaData.id} has been successfully updated.`,
                status: "success",
                duration: 3000,
                isClosable: true,
            });
        } else {
            console.warn(
                "update-enrolment returned unexpected status:",
                response.data.status,
                "expected:",
                EnrolmentStatus.UNDER_REVIEW
            );
            toast({
                title: "Update Incomplete",
                description: "The enrolment status was not updated to 'Under Review'.",
                status: "warning",
                duration: 3000,
                isClosable: true,
            });
        }
    } catch (error) {
        if (axios.isAxiosError(error)) {
            toast({
                title: "Error Updating Enrolment",
                description: error.response?.data?.detail || "Failed to update enrolment due to a server error.",
                status: "error",
                duration: 3000,
                isClosable: true,
            });
        } else {
            toast({
                title: "Unexpected Error",
                description: error instanceof Error ? error.message : "An unexpected error occurred.",
                status: "error",
                duration: 3000,
                isClosable: true,
            });
        }
        console.error("Error updating enrolment:", error);
    }
};

const createEnrolment = async (enrolmentData: EnrolmentData) => {
    // NEW — defensive sanitization independent of whatever EnrolmentForm's internal
    // state happened to be. Guarantees the wire payload matches enrolmentMode
    // regardless of toggle-timing edge cases.
    const sanitizedData: EnrolmentData = {
        ...enrolmentData,
        father: enrolmentMode === "online" ? null : enrolmentData.father,
        emergencyContact: enrolmentMode === "online" ? null : enrolmentData.emergencyContact,
        medicalAndOtherInfo: {
            ...enrolmentData.medicalAndOtherInfo,
            agreeToCosts: enrolmentMode === "online" ? null : enrolmentData.medicalAndOtherInfo.agreeToCosts,
        },
        enrolmentMode: enrolmentMode,
    };

    setEnrolmentDetails(sanitizedData);

    try {
        const apiurl = process.env.REACT_APP_API_URL || "https://default-url.com";

        const endpoint = enrolmentMode === "online" ? "/create-enrolment-online" : "/create-enrolment";

        const response = await axios.post(`${apiurl}${endpoint}`, sanitizedData, {
            headers: {
                Authorization: `Bearer ${localStorage.getItem('token')}`,
            },
        });

        toast({
            title: "Enrolment Submitted",
            description: `Enrolment No: ${response.data.enrolmentNo}`,
            status: "success",
            duration: 3000,
            isClosable: true,
            position: "top",
        });
        if (tenant && response.data.enrolmentId) {
            navigate(`/platform/${tenant.tenant_slug}/app/register-enrolled-student/review-enrolment/${response.data.enrolmentId}`);
        }
    } catch (error) {
        if (axios.isAxiosError(error)) {
            toast({
                title: "Error Creating Enrolment",
                description: error.response?.data?.detail || "Failed to update enrolment due to a server error.",
                status: "error",
                duration: 3000,
                isClosable: true,
            });
        } else {
            toast({
                title: "Unexpected Error",
                description: error instanceof Error ? error.message : "An unexpected error occurred.",
                status: "error",
                duration: 3000,
                isClosable: true,
            });
        }
        console.error("Error creating enrolment:", error);
    }
};

const saveStudentUser = async () => {
    const apiurl = process.env.REACT_APP_API_URL || "https://default-url.com";

    // Idempotency guard: if this enrolment already has a user_id, Step 2
    // already succeeded (possibly in an earlier, out-of-sync render). Don't call
    // CreateUser again — just re-sync local state and move on.
    if (enrolmentMetaData?.user_id) {
        console.log("Skipping CreateUser — user already exists for this enrolment:", enrolmentMetaData.user_id);
        toast({
            title: "Already Created",
            description: `A user already exists for this enrolment (User ID: ${enrolmentMetaData.user_id}). Skipping creation.`,
            status: "info",
            duration: 3000,
            isClosable: true,
        });
        return;
    }

    if (!studentUser) {
        console.error("Student User data is missing. Cannot update.");
        toast({
            title: "Missing Data",
            description: "Student User data is missing. Cannot update.",
            status: "error",
            duration: 3000,
            isClosable: true,
        });
        return;
    }

    try {
        const userResponse = await axios.post(`${apiurl}/CreateUser/`, studentUser, {
            headers: {
                Authorization: `Bearer ${localStorage.getItem('token')}`,
            },
        });

        const userId = userResponse.data.user_id;
        setStudentUser(userResponse.data);
        console.log("The user ID coming from the StudentUser table:", userId);

        if (!enrolmentMetaData) {
            console.error("Enrolment metadata is missing. Cannot update.");
            toast({
                title: "Missing Metadata",
                description: "Enrolment metadata is missing. Cannot update.",
                status: "error",
                duration: 3000,
                isClosable: true,
            });
            return;
        }

        if (!enrolmentMetaData.id) {
            throw new Error("Enrolment ID is missing. Cannot update.");
        }

        const normalizedUser = user ?? undefined;
        const updatedMetaData = {
            id: enrolmentMetaData.id,
            status: EnrolmentStatus.USER_CREATED,   // FIXED — was EnrolmentStatus.UNDER_REVIEW
            actioned_by: normalizedUser,
            created_at: enrolmentMetaData.created_at,
            updated_at: enrolmentMetaData.updated_at,
            user_id: userId,                        // FIXED — was undefined
            rejection_reason: rejectionReason,
            enrolmentMode: enrolmentMetaData.enrolmentMode,
        };

        setStudentMetaData({
            student_id: 0,
            is_active: true,
            user_id: userId,
            actioned_by: normalizedUser ?? "admin",
            created_at: enrolmentMetaData.created_at,
            updated_at: enrolmentMetaData.updated_at,
            enrolmentMode: enrolmentMetaData.enrolmentMode,
        });

        console.log("The user ID to be inserted in enrolment table:", updatedMetaData.user_id);

        const enrolmentResponse = await axios.put(
            `${apiurl}/update-enrolment-metadata/${enrolmentMetaData.id}`,
            updatedMetaData,
            {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem('token')}`,
                },
            }
        );

        setEnrolmentMetaData(enrolmentResponse.data);

        if (enrolmentResponse.data.status === EnrolmentStatus.USER_CREATED) {
            toast({
                title: "Enrolment Updated",
                description: `Enrolment with ID ${enrolmentMetaData.id} has been successfully updated.`,
                status: "success",
                duration: 3000,
                isClosable: true,
            });
        } else {
            console.warn(
                "update-enrolment-metadata returned unexpected status:",
                enrolmentResponse.data.status,
                "expected:",
                EnrolmentStatus.USER_CREATED
            );
            toast({
                title: "Update Failed",
                description: "Enrolment could not be updated.",
                status: "warning",
                duration: 3000,
                isClosable: true,
            });
        }

        console.log("Enrolment updated:", enrolmentResponse.data);
    } catch (error) {
        console.error("Error during saveStudentUser:", error);
        if (axios.isAxiosError(error)) {
            toast({
                title: "API Error",
                description: error.response?.data?.detail || "An error occurred while processing the request.",
                status: "error",
                duration: 3000,
                isClosable: true,
            });
        } else {
            toast({
                title: "Unexpected Error",
                description: "An unexpected error occurred.",
                status: "error",
                duration: 3000,
                isClosable: true,
            });
        }
    }
};
      
  const API_URL = process.env.REACT_APP_API_URL || "https://default-url.com";

  const saveStudentInEducationSchema = async () => {
    
      try {
        
           if (!enrolmentDetails) {
            toast({
                  title: "Error",
                  description: "Enrolment details are missing. Cannot update.",
                  status: "error",
                  duration: 3000,
                  isClosable: true,
              });
              return;
        }
          if (!enrolmentMetaData) {
              toast({
                  title: "Error",
                  description: "Enrolment metadata is missing. Cannot update.",
                  status: "error",
                  duration: 3000,
                  isClosable: true,
              });
              return;
          }
  
          if (!enrolmentMetaData.id) {
              throw new Error("Enrolment ID is missing. Cannot update.");
          }
  
          const normalizedUser = user ?? undefined;
  
          setStudentMetaData({
              student_id: 0,
              is_active : true,
              user_id: enrolmentMetaData.user_id ?? 0,
              actioned_by: normalizedUser ?? "admin",
              created_at: enrolmentMetaData.created_at,
              updated_at: enrolmentMetaData.updated_at,
              enrolmentMode: enrolmentMetaData.enrolmentMode,   // NEW
          });
  
          if (!studentMetaData || !studentMetaData.user_id) {
              throw new Error("Student metadata or User ID is missing. Cannot update.");
          }
          

          const payload: Student = {
              ...studentMetaData,
              ...enrolmentDetails,
          };
  
          const createStudentResponse = await axios.post(`${API_URL}/create-student/`, payload, {
              headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
          });
  
          if (createStudentResponse.data.isRegistrationSuccess) {
              toast({
                  title: "Success",
                  description: "Student successfully registered.",
                  status: "success",
                  duration: 3000,
                  isClosable: true,
              });
              setStudentMetaData({
                  student_id: createStudentResponse.data.student_id,
                  is_active : createStudentResponse.data.is_active,
                  user_id: enrolmentMetaData.user_id ?? 0,
                  actioned_by: normalizedUser ?? "admin",
                  created_at: enrolmentMetaData.created_at,
                  updated_at: enrolmentMetaData.updated_at,
                  enrolmentMode: enrolmentMetaData.enrolmentMode,   // NEW
              });
          } else {
              throw new Error("Student registration failed.");
          }
  
          const updatedMetaData = {
              id: enrolmentMetaData.id,
              status: EnrolmentStatus.EXECUTED,
              actioned_by: normalizedUser,
              created_at: enrolmentMetaData.created_at,
              updated_at: enrolmentMetaData.updated_at,
              user_id: enrolmentMetaData.user_id,
              rejection_reason : rejectionReason,
          };
  
          await updateEnrolmentMetadata(updatedMetaData);
  
          if (studentUser) {
              const userPayload = {
                  username: studentUser.username,
                  email: studentUser.email,
                  password: "",
                  tenant_id: studentUser.tenant_id,
                  role_id: studentUser.role_id,
                  is_active: true,
              };
  
              await updateUser(studentUser.user_id, userPayload);
          }
      } catch (error) {
          handleError(error, "Error updating enrolment.");
      }
  };
  
  const confirmEnrolmentReview = async () => {
      try {
          if (!enrolmentMetaData) {
              toast({
                  title: "Error",
                  description: "Enrolment metadata is missing. Cannot update.",
                  status: "error",
                  duration: 3000,
                  isClosable: true,
              });
              return;
          }
  
          if (!enrolmentMetaData.id) {
              throw new Error("Enrolment ID is missing. Cannot update.");
          }
  
          const normalizedUser = user ?? undefined;
  
          const updatedMetaData = {
              id: enrolmentMetaData.id,
              status: EnrolmentStatus.REVIEWED,
              actioned_by: normalizedUser,
              created_at: enrolmentMetaData.created_at,
              updated_at: enrolmentMetaData.updated_at,
              user_id: enrolmentMetaData.user_id,
              rejection_reason : rejectionReason,
          };
  
          const response = await axios.put(
              `${API_URL}/update-enrolment-metadata/${enrolmentMetaData.id}`,
              updatedMetaData,
              { headers: { Authorization: `Bearer ${localStorage.getItem("token")}` } }
          );

          setEnrolmentMetaData(response.data);
  
          if (response.data.status === "reviewed") {
              toast({
                  title: "Success",
                  description: "Enrolment successfully reviewed.",
                  status: "success",
                  duration: 3000,
                  isClosable: true,
              });
              
          } else {
              throw new Error("Enrolment review failed.");
          }
      } catch (error) {
          handleError(error, "Error reviewing enrolment.");
      }
  };
  
  const updateEnrolmentMetadata = async (updatedMetaData: any) => {
      try {
          const response = await axios.put(
              `${API_URL}/update-enrolment-metadata/${updatedMetaData.id}`,
              updatedMetaData,
              { headers: { Authorization: `Bearer ${localStorage.getItem("token")}` } }
          );

          setEnrolmentMetaData(response.data);
  
          toast({
              title: "Success",
              description: `Enrolment with ID ${updatedMetaData.id} updated successfully.`,
              status: "success",
              duration: 3000,
              isClosable: true,
          });
  
          return response.data;
      } catch (error) {
          handleError(error, "Error updating enrolment metadata.");
      }
  };
  
  const updateUser = async (userId: number, payload: any) => {
      try {
          await axios.put(`${API_URL}/update-user/${userId}`, payload, {
              headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
          });
  
          toast({
              title: "Success",
              description: "User updated successfully.",
              status: "success",
              duration: 3000,
              isClosable: true,
          });
      } catch (error) {
          handleError(error, "Error updating user.");
      }
  };
  
  const handleError = (error: unknown, fallbackMessage: string) => {
      if (axios.isAxiosError(error)) {
          toast({
              title: "Error",
              description: error.response?.data?.detail || fallbackMessage,
              status: "error",
              duration: 3000,
              isClosable: true,
          });
      } else {
          toast({
              title: "Error",
              description: fallbackMessage,
              status: "error",
              duration: 3000,
              isClosable: true,
          });
      }
  };

  const parsedId = enrolment_id ? Number(enrolment_id) : null;
  const isCreateByAdmin = parsedId === 0;

  return (
    <Box as="main" mx="auto" p={10} >
        <Box p={4} borderColor={"gray.300"} borderWidth={1} borderRadius="sm" mb={4}>
            {enrolmentMetaData && enrolmentDetails? (
                <Table variant="simple" size="sm" mb={2}>
                    <Tbody>
                        <Tr>
                            <Td fontSize="lg" fontWeight="bold">Enrolment Details</Td>
                            <Td>     
                                <Button
                                    mt={4}
                                    colorScheme="red"
                                    onClick={() => handleReject()}
                                    isDisabled={confirmedSteps.includes(3)} 
                                    alignSelf={"flex-end"}>
                                    Reject
                                </Button>
                            </Td>
                        </Tr>
                        <Tr>
                            <Td fontWeight="bold">Enrolment ID</Td>
                            <Td>{enrolmentMetaData.id}</Td>
                        </Tr>
                        <Tr>
                            <Td fontWeight="bold">Student Name</Td>
                            <Td>{enrolmentDetails.student.givenName + ' '+ enrolmentDetails.student.surname }</Td>
                        </Tr>
                        <Tr>
                            <Td fontWeight="bold">Status</Td>
                            <Td>{enrolmentMetaData.status}</Td>
                        </Tr>
                        <Tr>
                            <Td fontWeight="bold">Actioned By</Td>
                            <Td>{enrolmentMetaData.actioned_by || "N/A"}</Td>
                        </Tr>
                        <Tr>
                            <Td fontWeight="bold">Created At</Td>
                            <Td>{fmtLocal(enrolmentMetaData.created_at)}</Td>
                        </Tr>
                        <Tr>
                            <Td fontWeight="bold">Updated At</Td>
                             <Td>{fmtLocal(enrolmentMetaData.updated_at)}</Td>
                           
                        </Tr>
                    </Tbody>
                </Table>
            ) : (
                <Text>No Student Meta Data Yet</Text>
            )}
        </Box>

        <AlertDialog isOpen={isOpen} leastDestructiveRef={cancelRef} onClose={onClose}>
                <AlertDialogOverlay>
                    <AlertDialogContent>
                        <AlertDialogHeader fontSize="lg" fontWeight="bold">
                            Confirm Rejection
                        </AlertDialogHeader>

                        <AlertDialogBody>
                            <Text mb={4}>
                                Are you sure you want to reject this enrolment? This action
                                cannot be undone.
                            </Text>
                            <Select
                                placeholder="Select a rejection reason"
                                value={rejectionReason}
                                onChange={(e) => setRejectionReason(e.target.value)}
                            >
                                <option value="Duplicate">Duplicate</option>
                                <option value="Garbage">Garbage</option>
                                <option value="Network DDoS">Network DDoS</option>
                            </Select>
                        </AlertDialogBody>

                        <AlertDialogFooter>
                        <Button ref={cancelRef} onClick={onClose}>
                            Cancel
                        </Button>
                        <Button
                            colorScheme="red"
                            onClick={handleRejectConfirmed}
                            ml={3}
                            isDisabled={!rejectionReason} // Disable if no reason selected
                        >
                            Confirm
                        </Button>
                        </AlertDialogFooter>
                    </AlertDialogContent>
                </AlertDialogOverlay>
            </AlertDialog>
    
    <Accordion allowToggle>
    <AccordionItem key="step1" isDisabled={!enabledSteps.includes(0)}>
        <h2>
         <AccordionButton
        height="60px"
        bg={enabledSteps.includes(0) ? "white" : "gray.50"}
        _hover={{ bg: "gray.100" }}
        _expanded={{ bg: "gray.300", borderBottom: "1px solid", borderColor: "gray.400" }}
        fontWeight="bold"
      >
        <Box flex="1" textAlign="left">
          Step 1: Review Enrolment{" "}
          {badges[0] && (
            <Badge ml="2" colorScheme={badges[0] === "Confirmed" ? "green" : "blue"}>
              {badges[0]}
            </Badge>
          )}
        </Box>
        <AccordionIcon />
      </AccordionButton>
    </h2>
    <AccordionPanel pb={4}>
      <Text mb={4}>Review and update enrolment details in staging.</Text>
      <Box>
        <Text fontWeight="bold" mb={2}>
          Enrolment Form:
        </Text>
            
            {/* admin create-by-admin flow stays offline unless you add a mode toggle here later */}
                <Box>
                {isCreateByAdmin && tenant ? (
                    <>
                    {/* Enrolment Mode */}
                    <Box
                        mb={6}
                        p={4}
                        bg={enrolmentModeBg}
                        border="1px solid"
                        borderColor={enrolmentModeBorder}
                        borderRadius="lg"
                    >
                        <HStack justify="space-between" align="center">
                        <Box>
                            <Text fontWeight="semibold">
                            Enrolment Mode
                            </Text>

                            <Text
                            fontSize="sm"
                            color={enrolmentModeMuted}
                            mt={1}
                            >
                            Choose how this enrolment will be recorded and processed.
                            </Text>
                        </Box>

                        <HStack spacing={3}>
                            <Text
                            fontSize="sm"
                            fontWeight={
                                enrolmentMode === "offline" ? "semibold" : "normal"
                            }
                            color={
                                enrolmentMode === "offline"
                                ? enrolmentModeActive
                                : enrolmentModeInactive
                            }
                            >
                            Offline
                            </Text>

                            <Switch
                            isChecked={enrolmentMode === "online"}
                            onChange={(e) =>
                                setEnrolmentMode(
                                e.target.checked ? "online" : "offline"
                                )
                            }
                            colorScheme="blue"
                            size="md"
                            />

                            <Text
                            fontSize="sm"
                            fontWeight={
                                enrolmentMode === "online" ? "semibold" : "normal"
                            }
                            color={
                                enrolmentMode === "online"
                                ? enrolmentModeActive
                                : enrolmentModeInactive
                            }
                            >
                            Online
                            </Text>
                        </HStack>
                        </HStack>
                    </Box>

                    <EnrolmentForm
                        mode="create-by-admin"
                        enrolmentMode={enrolmentMode}
                        tenantId={tenant.tenant_id}
                        tenantName={tenant.tenant_name}
                        studentEnrolmentData={undefined}
                        onSave={createEnrolment}
                        formReset={false}
                    />
                    </>
                ) : enrolmentDetails ? (
                    <EnrolmentForm
                    mode="review"
                    enrolmentMode={enrolmentDetails.enrolmentMode ?? "offline"}
                    studentEnrolmentData={enrolmentDetails}
                    onSave={updateEnrolment}
                    formReset={false}
                    />
                ) : (
                    <Text>No enrolment data available.</Text>
                )}

                {message && (
                    <Alert status="info" mt={4}>
                    <AlertIcon />
                    {message}
                    </Alert>
                )}
                </Box>
      </Box>
    <Button
        mt={4}
        colorScheme="teal"
        onClick={() => handleConfirm(0)}
        isDisabled={confirmedSteps.includes(1) || processingStep !== null}
        isLoading={processingStep === 0}
    >
        Confirm and Continue
    </Button>
    </AccordionPanel>
  </AccordionItem>

  <AccordionItem key="step2" isDisabled={!enabledSteps.includes(1)}>
    <h2>
      <AccordionButton
        height="60px"
        bg={enabledSteps.includes(1) ? "white" : "gray.50"}
        _hover={{ bg: "gray.100" }}
        _expanded={{ bg: "gray.300", borderBottom: "1px solid", borderColor: "gray.400" }}
        fontWeight="bold"
      >
        <Box flex="1" textAlign="left">
          Step 2: Create User{" "}
          {badges[1] && (
            <Badge ml="2" colorScheme={badges[1] === "Confirmed" ? "green" : "blue"}>
              {badges[1]}
            </Badge>
          )}
        </Box>
        <AccordionIcon />
      </AccordionButton>
    </h2>
    <AccordionPanel pb={4}>
      <Text mb={4}>Create User for the Student.</Text>
      <Box>
        <Text fontWeight="bold" mb={2}>
          Create User for Student:
        </Text>
        {studentUser ? (
          <Table variant="simple" size="sm">
            <Tbody>
              <Tr>
                <Td fontWeight="bold">Student's User Name</Td>
                <Td>{studentUser.username}</Td>
              </Tr>
              <Tr>
                <Td fontWeight="bold">Student's Email</Td>
                <Td>{studentUser.email}</Td>
              </Tr>
              <Tr>
                <Td fontWeight="bold">Student's Initial Password</Td>
                <Td>{studentUser.password}</Td>
              </Tr>
              <Tr>
                <Td fontWeight="bold">Student's User ID</Td>
                <Td>{studentUser.user_id}</Td>
              </Tr>
            </Tbody>
          </Table>
        ) : (
          <Text>Loading student's user details...</Text>
        )}
      </Box>
    <Button
        mt={4}
        colorScheme="teal"
        onClick={() => handleConfirm(1)}
        isDisabled={confirmedSteps.includes(2) || processingStep !== null}
        isLoading={processingStep === 1}
    >
        Confirm and Continue
    </Button>
    </AccordionPanel>
  </AccordionItem>

  <AccordionItem key="step3" isDisabled={!enabledSteps.includes(2)}>
    <h2>
      <AccordionButton
        height="60px"
        bg={enabledSteps.includes(2) ? "white" : "gray.50"}
        _hover={{ bg: "gray.100" }}
        _expanded={{ bg: "gray.300", borderBottom: "1px solid", borderColor: "gray.400" }}
        fontWeight="bold"
      >
        <Box flex="1" textAlign="left">
          Step 3: Create Student{" "}
          {badges[2] && (
            <Badge ml="2" colorScheme={badges[2] === "Confirmed" ? "green" : "blue"}>
              {badges[2]}
            </Badge>
          )}
        </Box>
        <AccordionIcon />
      </AccordionButton>
    </h2>
    <AccordionPanel pb={4}>
      <Text mb={4}>Create Student and attach to the User created in the previous step.</Text>
      <Box>
        <Text fontWeight="bold" mb={2}>
          Creating Student in Final Education Schema:
        </Text>
        {studentUser && studentMetaData ? (
          <Table variant="simple" size="sm">
            <Tbody>
              <Tr>
                <Td fontWeight="bold">Student's User Name</Td>
                <Td>{studentUser.username}</Td>
              </Tr>
              <Tr>
                <Td fontWeight="bold">Student's Email</Td>
                <Td>{studentUser.email}</Td>
              </Tr>
              <Tr>
                <Td fontWeight="bold">Student's User ID</Td>
                <Td>{studentUser.user_id}</Td>
              </Tr>
              <Tr>
                <Td fontWeight="bold">Student ID</Td>
                <Td>{studentMetaData.student_id}</Td>
              </Tr>
            </Tbody>
          </Table>
        ) : (
          <Text>Loading student's user details...</Text>
        )}
      </Box>
<Button
    mt={4}
    colorScheme="teal"
    onClick={() => handleConfirm(2)}
    isDisabled={confirmedSteps.includes(3) || processingStep !== null}
    isLoading={processingStep === 2}
>
    Confirm and Continue
</Button>
    </AccordionPanel>
  </AccordionItem>
</Accordion>
      </Box>
        
  );
};

export default ReviewEnrolment;

